import { render, staticRenderFns } from "./PointPicker.vue?vue&type=template&id=66a89832&scoped=true"
import script from "./PointPicker.vue?vue&type=script&lang=js"
export * from "./PointPicker.vue?vue&type=script&lang=js"
import style0 from "./PointPicker.vue?vue&type=style&index=0&id=66a89832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a89832",
  null
  
)

export default component.exports